document.addEventListener('DOMContentLoaded', () => {

    //  Removed external upcart link that was causing trouble 

    const upcartCSS = document.querySelector('#upcart-stylesheet');
    if (upcartCSS) upcartCSS.remove();

    // Remove subtotal from checkout button
    function removeSubTotalFromCheckout() {
        let shadowRoot = document.querySelector('#upCart').shadowRoot;
            
        let checkoutBtn = shadowRoot.querySelector('.upcart-checkout-button');

        let checkoutTxt = checkoutBtn.innerHTML;
        checkoutBtn.innerHTML = checkoutTxt.split(" ")[0];
    }

    //Add taxes text below subtotal

    function addTaxesText() {
        let shadowRoot = document.querySelector('#upCart').shadowRoot;
        let taxesTxt = shadowRoot.querySelector('.taxes-txt');

        if (taxesTxt) return 
            
        let subtotal = shadowRoot.querySelector('.styles_Footer__cartSummarySection__');
        subtotal.insertAdjacentHTML('afterend', '<p class="taxes-txt" style="font-size: 14px;">Excluding taxes and shipping</p>');

    }

    function removePayForFreeReturns() {

        console.log("REEEEEMOOVIIINNNNN")
        let shadowRoot = document.querySelector('#upCart').shadowRoot;
        let upsells = shadowRoot.querySelectorAll('#up-upsell-carousel .upcart-do-not-modify-this-node-please-only-modify-child-node');

        let removedFreeReturns = false;

        upsells.forEach(upsell => {
            if (removedFreeReturns) return;

            // Check if the upsell item contains "free returns"
            // and remove it if it does

            let itemTitle = upsell.querySelector('.upcart-upsell-item-title').innerHTML;
            if (itemTitle.includes('free returns')) {
                removedFreeReturns = true;
                upsell.remove();
            }
        });
    }

    window.upcartOnCartUpdated = (cart) => {

        /* Execute everything with a brief timeout so elements load */

        setTimeout(() => {
            removeSubTotalFromCheckout();
            addTaxesText();
        }, 50);
    }

    /* First time executions */

    setTimeout(() => {
        removeSubTotalFromCheckout();
        addTaxesText();
    }, 1000);

    /* Even larger timeout for AI suggestions cherry pick removal */

    setTimeout(() => {
        removePayForFreeReturns();
    }, 3000);

});

